export var EMappepMenuEventCodes;
(function (EMappepMenuEventCodes) {
    EMappepMenuEventCodes["ARROW_DOWN"] = "ArrowDown";
    EMappepMenuEventCodes["ARROW_UP"] = "ArrowUp";
    EMappepMenuEventCodes["ENTER"] = "Enter";
    EMappepMenuEventCodes["ESC"] = "Escape";
    EMappepMenuEventCodes["ARROW_RIGHT"] = "ArrowRight";
    EMappepMenuEventCodes["ARROW_LEFT"] = "ArrowLeft";
})(EMappepMenuEventCodes || (EMappepMenuEventCodes = {}));
